import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicDownload({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.98 7.83c.43 0 .77.34.77.76v4.62c0 .85-.69 1.54-1.54 1.54H2.8c-.85 0-1.54-.69-1.54-1.54V8.6a.77.77 0 011.53 0v4.62h10.43V8.6c0-.42.35-.76.77-.76zm-6.43 2.35l-.05-.03-.06-.05-2.23-2.16A.8.8 0 016.23 6.7l.1.07.86.85V2.05a.8.8 0 011.6-.1l.01.1v5.58l.87-.85a.8.8 0 011.2 1.07l-.08.09-2.23 2.16-.07.05-.05.04-.06.03-.05.03-.1.03-.11.03a.8.8 0 01-.47-.07l-.1-.06z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicDownload.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicDownload.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicDownload svgRef={ref} {...props} />);
export default ForwardRef;
